<template>
  <div class="main-container">
    <page-header>{{ '已提交摘要' | dealLanguage('My Abstracts') }}</page-header>
    <div class="flex-wrapper">
      <div class="flex-left">
        <user-info-nav></user-info-nav>
      </div>
      <div class="flex-right">
        <div class="contribution-grid" v-if="list.length">
          <div class="contribution-card" v-for="item in list" :key="item.id">
            <div class="card-top">
              <div class="card-title">{{ item.title | empty }}</div>
              <div :class="['status-tag', statusClass(item.status)]">
                {{ statusText(item.status) }}
              </div>
            </div>
            <div class="card-content">
              <div class="card-info">
                <div class="info-row">
                  <i class="iconfont">&#xe70a;</i>
                  <span>{{ item.compName | empty }}</span>
                </div>
                <div class="info-row">
                  <i class="iconfont">&#xe709;</i>
                  <span>{{ item.author | empty }}</span>
                </div>
              </div>
              <img
                :src="
                  static_img_url + 'pic/logo.png?v=' + $store.state.imgVersion
                "
                class="card-logo"
              />
            </div>
            <div class="card-bottom">
              <div class="submit-time" v-if="item.status == 1">
                {{ '提交时间' | dealLanguage('Submitted at') }}:
                {{ displayTime(item) | time_moment('YYYY-MM-DD HH:mm:ss') }}
              </div>
              <div v-else style="color: #C8161D;">未提交</div>
              <div class="actions">
                <Button type="primary" @click="handleEdit(item)">{{
                  '再次编辑' | dealLanguage('Edit Again')
                }}</Button>
              </div>
            </div>
          </div>
        </div>
        <div class="loading-warpper" v-if="loading">
          <van-loading size="20px"
            >{{ '加载中' | dealLanguage('Loading') }}...</van-loading
          >
        </div>
        <nothing v-if="!loading && list.length == 0">
          <router-link :to="{ name: 'abstractForm' }" class="btn">{{
            '去提交摘要' | dealLanguage('Submit Abstract')
          }}</router-link>
        </nothing>
        <div ref="indexlist-bottom"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import PageHeader from '@/components/pc/pageHeader.vue'
import UserInfoNav from '@/components/pc/userInfoNav.vue'
import { getContributionList } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('已提交摘要', 'My Abstracts'),
    }
  },
  components: {
    PageHeader,
    UserInfoNav,
    Nothing,
  },
  created() {
    if (!this.user_key) {
      this.$router.push({ name: 'index' })
      this.$Message.error(
        filter.dealLanguage('请先登录', 'Please log in first'),
      )
      return
    }
    this.fetchList()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      size: 10,
      count: 0,
      list: [],
      loading: false,
      isMore: false,
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      language: (state) => state.language,
      static_img_url: (state) => state.static_img_url,
    }),
  },
  methods: {
    statusText(status) {
      return String(status) === '1'
        ? filter.dealLanguage('已提交', 'Submitted')
        : filter.dealLanguage('草稿', 'Draft')
    },
    statusClass(status) {
      return String(status) === '1' ? 'submitted' : 'draft'
    },
    displayTime(item) {
      return item.submitTime || item.updateTime || item.createTime || ''
    },
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const listbox = this.$refs['indexlist-bottom']
      if (!listbox) return
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop
      if (
        scrollTop + windowHeight >= listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.isMore
      ) {
        this.page++
        this.fetchList()
      }
    },
    async fetchList() {
      this.loading = true
      let res = await getContributionList({
        getCount: true,
        page: this.page,
        size: this.size,
      })
      this.loading = false
      if (res.code == 0) {
        const data = res.data || {}
        const contributions = data.contributions || []
        this.list = [...this.list, ...contributions]
        this.count = data.count || 0
        this.isMore = this.list.length < this.count
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleEdit(item) {
      this.$router.push({
        name: 'abstractForm',
        query: {
          id: item.id,
        },
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'

.flex-right
  padding 30px 120px 30px 0

.contribution-grid
  display grid
  grid-template-columns repeat(2, 1fr)
  gap 20px

.contribution-card
  border 1px solid #E8E8E8
  border-radius 12px
  padding 24px
  background #FFFFFF
  display flex
  flex-direction column

.card-top
  display flex
  align-items flex-start
  justify-content space-between
  gap 12px

.card-title
  flex 1
  font-weight: 700;
  font-size: 18px;
  color: #1F2937;
  line-height: 28px;
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
  overflow hidden

.status-tag
  flex-shrink 0
  padding 4px 10px
  border-radius 999px
  font-size 12px
  line-height 18px
  &.submitted
    color #08C161
    background #EAFBF2
  &.draft
    color #FF9700
    background #FFF4E5

.card-info
  .info-row
    display flex
    align-items center
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    & + .info-row
      margin-top 10px
    .iconfont
      margin-right 8px
      color #333333

.card-bottom
  margin-top 20px
  display flex
  align-items flex-end
  justify-content space-between
  gap 12px

.submit-time
  font-size 12px
  color #999999
  line-height 20px

.actions
  display flex
  gap 12px
  .ivu-btn-primary
    color #fff
    background-color #C8161D
    border-color #C8161D
    width: 100px;
    height: 32px;
    border-radius 4px
    font-size 13px
    &:hover
      background-color #E24147
      border-color #E24147
.card-content
  margin-top 18px
  flex 1
  display flex
  align-items flex-end
  justify-content space-between
  .card-logo
    width 100px
    height auto
</style>
